/**
 * DevExtreme (esm/renovation/ui/scroll_view/utils/get_scroll_top_max.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function getScrollTopMax(element) {
    return element.scrollHeight - element.clientHeight
}
